import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

const getUserTrackedTrainerSlice = createSlice({
    name: 'UserTrackedTrainer',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchUserTrackedTrainer.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchUserTrackedTrainer.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE
            })
            .addCase(fetchUserTrackedTrainer.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            })
    }
});

export const { setUserTrackedTrainer, setStatus } = getUserTrackedTrainerSlice.actions;
export default getUserTrackedTrainerSlice.reducer;

export const fetchUserTrackedTrainer = createAsyncThunk('/UserTrackedTrainerget/fetch', async ({token}) => {
    const res = await axios.get(`${getBaseUrl()}/UserTrackedTrainer`,{
        headers: { "Authorization": token, 'x-xsrf-token': token }
    });
    const UserTrackedTrainerData = res.data;
    return UserTrackedTrainerData.data;
})
